<div class="moneda-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Empresa
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row company-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label> Nombre </mat-label>
              <input matInput name="name" formControlName="name" type="text" #nameInput
                [readonly]="readOnly || editLogo" [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['name']?.errors?.['required']">
              Nombre obligatorio
            </mat-error>
            <mat-error *ngIf="submitted && f['phone']?.errors?.['nameBillingRequired']">
              Nombre obligatorio para crear factura
            </mat-error>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label>
                País
              </mat-label>
              <mat-select name="country" formControlName="country" [disabled]="readOnly || editLogo"
                [ngClass]="{ 'is-invalid': submitted && f['country'].errors }">
                <mat-option *ngFor="let country of countries" [value]="country._id">{{country.name}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-error *ngIf="submitted && f['country']?.errors?.['required']">
              País obligatorio
            </mat-error>
          </div>
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Dirección fiscal </mat-label>
              <input matInput name="address" formControlName="address" type="text" #nameInput [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['address'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['address']?.errors?.['required']">
              Dirección fiscal obligatoria
            </mat-error>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label> Email de contacto </mat-label>
              <input matInput name="email" formControlName="email" type="text" #nameInput [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['email']?.errors?.['required']">
              Email de contacto obligatorio
            </mat-error>
            <mat-error *ngIf="submitted && f['phone']?.errors?.['emailBillingRequired']">
              Email de contacto obligatorio para crear factura
            </mat-error>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="outline">
              <mat-label> Teléfono de contacto </mat-label>
              <input matInput name="phone" formControlName="phone" type="text" #nameInput [readonly]="readOnly"
                [ngClass]="{ 'is-invalid': submitted && f['phone'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['phone']?.errors?.['required']">
              Teléfono de contacto obligatorio
            </mat-error>
            <mat-error *ngIf="submitted && f['phone']?.errors?.['phoneBillingRequired']">
              Teléfono de contacto obligatorio para crear factura
            </mat-error>
          </div>
          <div class="col-md-12">
            <mat-form-field appearance="outline">
              <mat-label> Número de Identificación Fiscal </mat-label>
              <input matInput name="taxId" formControlName="taxId" type="text" [readonly]="readOnly">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['taxId']?.errors?.['taxIdBillingRequired']">
              Número de identificación fiscal obligatorio para crear factura
            </mat-error>
          </div>
          <div class="col-6">
            <label>Logo:</label><br>
            <ng-container *ngIf="company?.logo?.fileUrl">
              <!--img class="image-preview cursor-pointer" [src]="company.logo.fileUrl" (click)="openLogo()" /-->
              <img class="image-preview cursor-pointer pt-3" [src]="company.logo?.fileUrl" />
            </ng-container>
          </div>
          <div class="col-6">
            <label>Cargar Nuevo Logo:</label>
            <app-file-uploader [fileLimit]="1" [fileAccept]="'image/jpg|image/png|image/jpeg|application/pdf'" [files]="[]"
              (uploading)="imagesOnChanging()" (updated)="imagesOnChange($event)">
            </app-file-uploader>
            <!--app-file-uploader fileLimit="1" fileAccept="image/*" [files]="[]" (updated)="imagesOnChange($event)"
              (uploading)="imagesOnChanging($event)">
            </app-file-uploader-->
          </div>
        </div>
        <div class="row" *ngIf="company._id && isDev">
          <div class="col-3">
            <label>
              Borrada? <br>
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" [disabled]="readOnly">
            </label>
          </div>
          <div class="col-9">
            <mat-form-field appearance="outline">
              <mat-label> Id </mat-label>
              <input matInput type="text" [value]="company._id" readonly>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="readOnly && !editLogo">
          <div class="col-12 pt-4">
            <button mat-raised-button type="button" class="m-0 ml-1 pull-left btn btn-manax"
              (click)="openSubscriptionModal()">
              Suscripcion
            </button>
          </div>
        </div>
        <div class="row" *ngIf="!readOnly || editLogo">
          <div class="col-12 pt-4">
            <button mat-raised-button [disabled]="uploading || saving" type="submit"
              class="m-0 ml-1 pull-right btn btn-manax">
              <span *ngIf="uploading || saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link d-none d-md-inline"
              (click)="dialog.close(false)">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>